import { render, staticRenderFns } from "./addSamNewCard.vue?vue&type=template&id=14120ab2"
import script from "./addSamNewCard.vue?vue&type=script&lang=js"
export * from "./addSamNewCard.vue?vue&type=script&lang=js"
import style0 from "./addSamNewCard.vue?vue&type=style&index=0&id=14120ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports